import { STATE_CODES_TO_STATE_NAME } from '../../constants';
import { getKeyByValue } from './object';
import { isString } from './string';

const fromStateToStateCode = state => {
  const stateCode = getKeyByValue(STATE_CODES_TO_STATE_NAME, state.toLowerCase());
  return isString(stateCode) ? stateCode.toUpperCase() : null;
};

export { fromStateToStateCode };
